/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var ActionResultStatus;
(function (ActionResultStatus) {
    ActionResultStatus["DONE"] = "DONE";
    ActionResultStatus["ARCHIVED"] = "ARCHIVED";
})(ActionResultStatus || (ActionResultStatus = {}));
